import React from "react";

// Scss imports
import css from "./Button.module.scss";

interface ButtonProps {
  text?: string;
  icon?: any;
  onButtonClickHandler: Function;
  style?: object;
  refButton?: any;
  disabledButton?: boolean;
  buttonClicked?: boolean;
  hidden?: boolean;
  type?: string;
}

const Button: React.FC<ButtonProps> = ({
  text,
  icon,
  onButtonClickHandler,
  style,
  refButton,
  disabledButton,
  buttonClicked,
  hidden,
  type,
}) => {
  return (
    <>
      {!hidden && (
        <button
          ref={refButton}
          type="submit"
          onClick={(e) => {
            e.preventDefault();
            onButtonClickHandler(e);
          }}
          className={`${type === "fixed" ? css.fixedWidth : ""} ${
            type === "papersNavigationButton" ? css.papersNavigationButton : ""
          } ${type === "processorsButton" ? css.processorsButton : ""} ${
            css.button
          } ${buttonClicked ? css.buttonClicked : null} ${
            type === "filterButton" ? css.filterButton : ""
          }`}
          style={style}
          disabled={disabledButton}
        >
          {text}
          {icon}
        </button>
      )}
    </>
  );
};

export default Button;
